/**
 * Firebase Authentication for Chore Champion.
 *
 * Accounts are email and password based. Everything else the app used to keep
 * on the Parse user object (pin, theme, login history) lives in the
 * users/{uid} profile document, which is created here on sign up.
 */
import { auth } from "./firebase";
import { getUserProfile, clearUserProfileCache } from "./db";

/**
 * @description Creates a family account and signs it in.
 * @return {Promise.<Object>} The Firebase user record.
 */
export async function signUp(email, password) {
  const credential = await auth.createUserWithEmailAndPassword(email, password);
  clearUserProfileCache();
  const profile = await getUserProfile();
  profile.set("email", email);
  profile.set("username", email);
  profile.set("app", "hero");
  profile.set("logins", [Date.now()]);
  await profile.save();
  return credential.user;
}

/**
 * @description Signs an existing account in.
 * @return {Promise.<Object>} The Firebase user record.
 */
export async function signIn(email, password) {
  const credential = await auth.signInWithEmailAndPassword(email, password);
  clearUserProfileCache();
  return credential.user;
}
